module.exports = __webpack_public_path__ + "img/parliament-6.05319a64.webp";